import { create } from 'zustand';

interface DemoTourState {
  touring: boolean;
  highlights: string[];
  alarmLoopActive: boolean;
  trafficVisible: boolean;
  startTour: () => void;
  endTour: () => void;
  setHighlights: (ids: string[]) => void;
  startAlarmLoop: () => void;
  stopAlarmLoop: () => void;
  setTrafficVisible: (v: boolean) => void;
}

export const useDemoTour = create<DemoTourState>((set) => ({
  touring: false,
  highlights: [],
  alarmLoopActive: false,
  trafficVisible: true,
  startTour: () => set({ touring: true, highlights: [], alarmLoopActive: false, trafficVisible: true }),
  endTour: () => set({ touring: false, highlights: [] }),
  setHighlights: (ids) => set({ highlights: ids }),
  startAlarmLoop: () => set({ alarmLoopActive: true }),
  stopAlarmLoop: () => set({ alarmLoopActive: false }),
  setTrafficVisible: (v) => set({ trafficVisible: v }),
}));
